/**
 * Shared loading-state helpers for cart mutations.
 *
 * Keeps the visible control, aria-busy state, repeat-click protection and the
 * theme's global loading bar in sync for PDP and cart-drawer actions.
 */
(function () {
  'use strict';

  var activeActions = 0;

  function startGlobalLoading() {
    activeActions += 1;
    if (activeActions === 1) document.dispatchEvent(new CustomEvent('theme:loading:start'));
  }

  function stopGlobalLoading() {
    activeActions = Math.max(0, activeActions - 1);
    if (activeActions === 0) document.dispatchEvent(new CustomEvent('theme:loading:end'));
  }

  function begin(button, loadingText, scope, drawer) {
    var state = {
      button: button || null,
      scope: scope || null,
      drawer: drawer || (scope && scope.closest ? scope.closest('#CartDrawer') : null),
      ended: false
    };

    if (state.button) {
      state.label = state.button.querySelector('[data-loading-label]') || state.button.querySelector('span') || state.button;
      state.idleLabel = state.label.textContent;
      state.wasDisabled = !!state.button.disabled;
      state.previousAriaBusy = state.button.getAttribute('aria-busy');
      state.button.classList.add('RpCartAction--loading');
      state.button.setAttribute('aria-busy', 'true');
      state.button.disabled = true;
      if (loadingText) state.label.textContent = loadingText;
    }

    if (state.scope) {
      state.previousScopeAriaBusy = state.scope.getAttribute('aria-busy');
      state.scope.classList.add('RpCartScope--loading');
      state.scope.setAttribute('aria-busy', 'true');
    }

    if (state.drawer) {
      state.previousDrawerAriaBusy = state.drawer.getAttribute('aria-busy');
      state.drawer.classList.add('RpCartDrawer--busy');
      state.drawer.setAttribute('aria-busy', 'true');
    }

    startGlobalLoading();
    return state;
  }

  function restoreAttribute(element, name, previousValue) {
    if (!element) return;
    if (previousValue == null) element.removeAttribute(name);
    else element.setAttribute(name, previousValue);
  }

  function end(state) {
    if (!state || state.ended) return;
    state.ended = true;

    if (state.button) {
      state.button.classList.remove('RpCartAction--loading');
      restoreAttribute(state.button, 'aria-busy', state.previousAriaBusy);
      state.button.disabled = state.wasDisabled;
      if (state.label) state.label.textContent = state.idleLabel;
    }

    if (state.scope) {
      state.scope.classList.remove('RpCartScope--loading');
      restoreAttribute(state.scope, 'aria-busy', state.previousScopeAriaBusy);
    }

    if (state.drawer) {
      state.drawer.classList.remove('RpCartDrawer--busy');
      restoreAttribute(state.drawer, 'aria-busy', state.previousDrawerAriaBusy);
    }

    stopGlobalLoading();
  }

  window.RPCartLoading = {
    beginButton: function (button, loadingText, scope, drawer) {
      return begin(button, loadingText, scope, drawer);
    },
    beginScope: function (scope, drawer) {
      return begin(null, null, scope, drawer);
    },
    end: end
  };
})();
